import styled from "styled-components"
import { Button } from "@theguarantors/ui-kit-v2"
import { theme } from "@theguarantors/ui-kit-v2/dist/design-system"
import { breakpoints } from "@theguarantors/ui-kit-v2/dist/design-system/breakpoints"

import thumbsUpSrc from "../../../../assets/thumbs-up.png"

export const SubmitButton = styled(Button)`
  font-size: 2.1rem;
  line-height: 2.6rem;
  width: 20rem;

  @media(max-width: ${breakpoints[0]}) {
    text-align: center;
  }
`

export const BackButton = styled(Button)`
  text-align: right;
  min-width: 8rem;
  width: 8rem;
  padding-right: 0;

  @media(max-width: ${breakpoints[0]}) {
    text-align: center;
  }
`

export const ErrorMessage = styled.div`
  color: ${theme.colors.red};
  font-family: ${theme.fonts.bold};
  font-size: 2rem;
  line-height: 1.25;
`
export const ThumbsUpIcon = styled.img.attrs(({ src = thumbsUpSrc }) => ({ src }))`
  height: 6rem;
  width: 6rem;
`
